import { takeEvery, put, call } from 'redux-saga/effects';
import { createEffect } from './creator';

import {
    SYSTEM_GET_SETTING,
    getSetting,
    SYSTEM_GET_WALLET,
    getWallet,
    SYSTEM_GET_MENU,
    getMenu,
    SYSTEM_GET_THEME,
    getTheme,
} from '../actions/system';
import SystemApi from 'pc-sales/api.v2/system';
import ThemeApi from 'pc-sales/api.v2/platform/theme';

export default [
    // 获取设置
    takeEvery(
        SYSTEM_GET_SETTING,
        createEffect(function* getSettingEffect(action: Action.Async): any {
            const { payload } = action;
            try {
                const data = yield call(SystemApi.getSetting, payload);
                yield put(getSetting.succeeded(data));
                return data;
            } catch (err) {
                yield put(getSetting.failed());
                throw err;
            }
        }),
    ),

    // 获取菜单
    takeEvery(
        SYSTEM_GET_MENU,
        createEffect(function* (action: Action.Async): any {
            const { payload } = action;
            const res = yield call(SystemApi.getMenu, payload);
            // 无参数请求保存结果（当前用户权限数据）
            yield put(getMenu.succeeded(!payload && res));
            return res;
        }),
    ),

    // 获取钱包设置
    takeEvery(
        SYSTEM_GET_WALLET,
        createEffect(function* (): any {
            try {
                const content = yield call(SystemApi.getWallet);
                yield put(getWallet.succeeded(content));
            } catch (err) {
                console.log(err);
                yield put(getWallet.failed());
                throw err;
            }
        }),
    ),

    // 获取主题图片（favicon/mainLogo/squareLogo/clientLoginBg）
    // Java 端可能自动生成 mainLogo/squareLogo 并回写，因此响应就是最新权威值。
    takeEvery(
        SYSTEM_GET_THEME,
        createEffect(function* (action: Action.Async) {
            const { payload } = action;
            const mode = payload?.mode || 'light';
            try {
                const data = yield call(ThemeApi.getTheme, mode);
                yield put(getTheme.succeeded({ mode, data }));
                return data;
            } catch (err) {
                yield put(getTheme.failed());
                throw err;
            }
        }),
    ),
];
